module.exports = __webpack_public_path__ + "img/ring_skip_0_1_null@2x.bb4e8836.png";